export default {
  namespaced: true,
  scripts: {
    title: "comandos",
    title_main: "comandos",
    action_add: 'Crear comando',
    action_update: 'Actualizar comando',
    base_commands: 'Comandos base',
    custom_commands: 'Comandos personalizados',
    fields: {
      name: {
        label: 'Nombre del comando',
        placeholder: 'Nombre del comando'
      },
      description: {
        label: 'Descripción del comando',
        placeholder: 'Descripción del comando'
      },
      requirements: {
        label: 'Requisitos (opcional)'
      }
    },
    messages: {
      success_created: 'Comando creado con éxito',
      success_updated: 'Comando actualizado con éxito',
      layout_empty: 'No se puede guardar un comando vacío',
      connections_empty: 'No se permiten nodos sin conexión',
      connections_qty_exceeded: 'No se permiten nodos con múltiples conexiones',
      incomplete_node_config: 'Configuración incompleta en los siguientes nodos',
    },
  },
};
